import { Spinner } from "reactstrap";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  buttonLabel?: string;
}

export const ButtonLoading: React.FC<ButtonProps> = ({ buttonLabel, loading, ...rest }) => (
  <button {...rest} className={`${rest?.className || ''} gm-button-loading`}>
    {loading && <Spinner />}
    {buttonLabel || ''}
  </button>
);
